import { AcceptPage } from '@/cms/definitions/content-types';
import { insuranceCompany } from '@/types/types';
import { ActionContext } from 'vuex';

export const ADD_PROPOSAL_STEPS = 'ADD_PROPOSAL_STEPS';
export const ADD_PROPOSAL_INFO = 'ADD_PROPOSAL_INFO';
export const PROPOSAL_INFO_ERROR = 'PROPOSAL_INFO_ERROR';
export const PROPOSAL_LOADED = 'PROPOSAL_LOADED';

export interface ProposalContextState {
	proposalSteps: Map<string, any>;
	party?: {
		address?: string;
		customer_no: string;
		name: string;
		customer_type: 'PRIMARY' | 'SECONDARY';
	};
	quote_id: string;
	customerNo: string;
	price: number;
	signatureId: string;
	timestamp: string;
	modal;
	originalRequest;
	insuranceCompanies: Array<insuranceCompany>;
	productProperties: Map<string, string>;
	policyListSorted?: string[];
}

const state: ProposalContextState = {
	proposalSteps: new Map(),
	party: undefined,
	quote_id: undefined,
	customerNo: undefined,
	price: undefined,
	signatureId: undefined,
	timestamp: '',
	modal: undefined,
	originalRequest: undefined,
	insuranceCompanies: undefined,
	productProperties: new Map([['is_auto_product', 'false']]),
	policyListSorted: undefined,
};

const mutations = {
	[ADD_PROPOSAL_STEPS](state: any, proposalSteps: Array<any>) {
		proposalSteps.forEach((step) => {
			state.proposalSteps.set(step.id, step);
		});
	},
	[ADD_PROPOSAL_INFO](state: any, proposalInfo: { proposal: any; cmsModel: AcceptPage }) {
		const { proposal, cmsModel } = proposalInfo;
		state.party = proposal.party;
		state.payment = proposal.payment;
		state.price = proposal.price;
		const policyListSorted: string[] = [];
		const types: string[] = [];
		for (const policy of proposal.policies) {
			if (!types.includes(policy.type)) {
				types.push(policy.type);
			}
			policyListSorted.push(policy.title);
		}
		policyListSorted.sort((a, b) => a.localeCompare(b));
		state.policyListSorted = policyListSorted;

		for (const policyTemplate of cmsModel.adjustPoliciesBlock?.policyBlock?.items || []) {
			if (types.includes(policyTemplate.content.type.toUpperCase()) && policyTemplate.content.productProperties) {
				policyTemplate.content.productProperties.forEach((item) => {
					state.productProperties.set(item.key, item.value);
				});
			}
		}
	},
	[PROPOSAL_INFO_ERROR](state: any) {
		//subscription event
	},
	[PROPOSAL_LOADED](state: any) {
		//subscription event
	},
};

const actions = {
	async [ADD_PROPOSAL_STEPS]({ commit, state, dispatch }: ActionContext<any, any>, proposalSteps: Array<any>) {
		commit(ADD_PROPOSAL_STEPS, proposalSteps);
	},
	async [ADD_PROPOSAL_INFO](
		{ commit, state, dispatch }: ActionContext<any, any>,
		proposalInfo: { proposalInfo: any; cmsModel: AcceptPage }
	) {
		commit(ADD_PROPOSAL_INFO, proposalInfo);
	},
	async [PROPOSAL_INFO_ERROR]({ commit, state, dispatch }: ActionContext<any, any>) {
		commit(PROPOSAL_INFO_ERROR);
	},
	async [PROPOSAL_LOADED]({ commit, state, dispatch }: ActionContext<any, any>) {
		commit(PROPOSAL_LOADED);
	},
};

export default {
	state,
	mutations,
	actions,
};
